import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgPublicEvent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M14.047 12.208l.318.863a1.086 1.086 0 01-.635 1.392l-3.939 1.47a1.075 1.075 0 01-1.383-.64l-.955-2.59 1.296-.484.85 2.302 3.362-1.256-.21-.572zM4.806 9.585l1.009 2.736-1.806.674L3 10.259zM16.64 0L21 11.823v.002l-1.805.673L14.835.673zm-2.026 1.953l3.584 9.718-11.805.173-.84-2.277z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('PublicEvent')(SvgPublicEvent);
